<ng-container *ngIf="isToday">
  <span>{{ value | date: 'hh:mm a' }}</span>
</ng-container>

<ng-container *ngIf="!isToday && isSameYear">
  <span>{{ value | date: 'E d MMM' }}</span>
</ng-container>

<ng-container *ngIf="!isToday && !isSameYear">
  <span>{{ value | date: 'E d MMM yyyy' }}</span>
</ng-container>

<ng-container *ngIf="noValue">
  <span></span>
</ng-container>
